import { gql } from "@apollo/client";

export const GET_ALL_TAGS_QUERY = gql`
  query Tags {
    tags {
      id
      name
    }
}
`;

export const GET_USER_TAGS_QUERY = gql`
  query UserTags($userId: ID!) {
    userTags(userId: $userId) {
      userId
      tagId
    }
}
`;

export const CREATE_TAG_MUTATION = gql`
  mutation Createtag($name: String!) {
    createTag(input: { name: $name }) {
      id
      name
    }
  }
`;

export const UPDATE_USER_TAGS_MUTATION = gql`
  mutation UpdateUserTags($userId: ID!, $tagIds: [ID!]!) {
    updateUserTags(
      userId: $userId
      tagIds: $tagIds
    ) {
      userId
      tagId
    }
  }
`;